import React, { useState } from 'react';

import Button from '../../elements/button';
import AddCouponModal from '../../widgets/modals/add-coupon';
import CouponListModal from '../../widgets/modals/view-coupon';
import MyProductsTable from './table';
import { closeModal, search } from '../../../public/assets/icons';
// import DateFilterComponent from "../../../widgets/filter/index.js";
import { Parser } from "json2csv";
import DatePickes from '../../widgets/filter';
const MyProductsSection = () => {
  const [addCouponModal, setAddCouponModal] = useState(false);
  const [openCouponListModal, setOpenCouponListModal] = useState(false);
  return (
    <section>
      {/* {addCouponModal && (
        <AddCouponModal setAddCouponModal={setAddCouponModal} />
      )} */}
      {/* {openCouponListModal && (
        <CouponListModal setOpenCouponListModal={setOpenCouponListModal} />
      )} */}

      {/* <div className="flex items-center">
        <div className="mb-6">
          <Button
            className="px-5 py-3 btn-primary"
            label="Add Coupon"
            onClick={() => setAddCouponModal(true)}
          />
        </div>
        <div className="mb-6 ml-2">
          <Button
            className="px-5 py-3 bg-secondary text-white"
            label="View Coupons"
            onClick={() => setOpenCouponListModal(true)}
          />
        </div>
      </div> */}


      <MyProductsTable />
    </section>
  );
};

export default MyProductsSection;
